/*
 @author       Holger Schauf
 @title        Switch Behavior
 @type         helper
 @description  toggle visibility by an element array

 @example      var switcher = new mote.Switcher();
 @example      mote.run('Switcher');
 */

mote.register('Switcher');

mote.Switcher = (function ($) {
    return Class.extend({
        init: function (cfg) {
            // set config
            this.cfg = Object.assign(
                {
                    trigger: null,
                    elements: [],
                    onToggle: function () {},
                },
                cfg
            );

            this.event();
        },

        event: function () {
            if (this.cfg.trigger !== null) {
                this.cfg.trigger.on(
                    'click.switch',
                    mote.doLater(this.toggle, this)
                );
            }
        },

        /**
         *
         * @param e
         * @returns {boolean}
         */
        toggle: function (e) {
            if (typeof e !== 'undefined') {
                e.preventDefault();
            }

            var elementsLength = this.cfg.elements.length,
                self = this;
            for (var i = 0; i < elementsLength; i++) {
                this.cfg.elements[i].toggle();
            }

            this.cfg.onToggle();

            return false;
        },

        addElement: function (el) {
            this.cfg.elements.push(el);
        },

        /**
         * remove events
         */
        remove: function () {
            this.cfg.trigger.off('click.switch');
        },
    });
})(jQuery);
